// Улучшенный AdaptivePagesSidebar.jsx с плавными анимациями
import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const AdaptivePagesSidebar = ({
  pages,
  activePage,
  onSelectPage,
  onBackToModules,
  isPagesMenuOpen,
  setIsPagesMenuOpen
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Управляем видимостью для плавной анимации
  useEffect(() => {
    const shouldShow = isMobile ? isPagesMenuOpen : true;
    
    if (shouldShow) {
      // Показываем элемент сразу, чтобы анимация началась
      setIsVisible(true);
    } else {
      // Задержка перед скрытием для завершения анимации закрытия
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isMobile, isPagesMenuOpen]);

  // Определяем, должен ли сайдбар быть открыт
  const shouldBeOpen = isMobile ? isPagesMenuOpen : true;

  // Всегда рендерим компонент если он должен быть видим или анимируется
  if (!isVisible) return null;

  return (
    <>
      {/* Overlay для мобильных с плавным появлением */}
      {isMobile && (
        <div
          className={`fixed inset-0 bg-black z-40 lg:hidden transition-opacity duration-300 ease-in-out ${
            isPagesMenuOpen 
              ? 'opacity-50 pointer-events-auto' 
              : 'opacity-0 pointer-events-none'
          }`}
          onClick={() => setIsPagesMenuOpen(false)}
        />
      )}

      <aside 
        className={`
          ${isMobile
            ? 'fixed top-12 right-0 z-50 h-full w-80 max-w-[85vw] transform'
            : 'relative w-64'
          }
          bg-white border-r border-gray-200 h-screen overflow-y-auto
          transition-all duration-300 ease-in-out
          ${isMobile 
            ? (shouldBeOpen 
                ? 'translate-x-0' 
                : 'translate-x-full'
              )
            : 'opacity-100'
          }
        `}
        style={isMobile ? {
          transform: shouldBeOpen ? 'translateX(0)' : 'translateX(100%)'
        } : {}}
      >
        <div className={`p-4 transition-opacity duration-300 ease-in-out ${
          shouldBeOpen ? 'opacity-100 delay-100' : 'opacity-0'
        }`}>
          {/* Шапка с кнопкой закрытия для мобильных */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold text-gray-800 pr-2 min-w-0 truncate">
              Уроки
            </h2>
            {isMobile && (
              <button
                onClick={() => setIsPagesMenuOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-md lg:hidden flex-shrink-0 
                         transition-colors duration-200 hover:scale-105 transform"
              >
                <X className="w-5 h-5" />
              </button>
            )}
          </div>

          <ul className="space-y-2">
            {Object.entries(pages).map(([pageId, page], index) => (
              <li
                key={pageId}
                className={`px-3 py-3 rounded-md cursor-pointer 
                          transition-all duration-200 transform hover:-translate-y-0.5 hover:shadow-sm
                          ${activePage === pageId
                            ? "bg-green-600 text-white shadow-md"
                            : "hover:bg-green-100 text-gray-700"
                          }`}
                style={{
                  transitionDelay: shouldBeOpen ? `${index * 30 + 150}ms` : '0ms'
                }}
                onClick={() => {
                  onSelectPage(pageId);
                  if (isMobile) setIsPagesMenuOpen(false);
                }}
              >
                <div className="font-medium truncate">{page.title}</div>
                <div className={`text-xs mt-1 ${
                  activePage === pageId ? 'text-green-100' : 'text-gray-500'
                }`}>
                  Урок {index + 1}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </>
  );
};

export default AdaptivePagesSidebar